<template>
    <div>
      <!-- ValidationProvider for validating the summernote editor's content -->
   
        <!-- Textarea where Summernote is applied -->
        <textarea ref="summernote"></textarea>
  
       
    </div>
  </template>
  
  <script>
  export default {
    name: 'SummernoteEditor',
    props: {
      value: String // Using 'value' for v-model
    },
    mounted() {
      this.initializeSummernote();
    },
    methods: {
      initializeSummernote() {
        // Initialize Summernote
        $(this.$refs.summernote).summernote({
          height: 300,
          placeholder: 'Type something amazing...',
          toolbar: [
            ['style', ['bold', 'italic', 'underline', 'clear']],
            ['font', ['strikethrough', 'superscript', 'subscript']],
            ['fontsize', ['fontsize']],
            ['color', ['color']],
            ['para', ['ul', 'ol', 'paragraph']],
            ['height', ['height']],
            ['insert', ['link', 'picture', 'video']]
          ],
          callbacks: {
            // Trigger when content changes in Summernote
            onChange: (content) => {
              this.updateModelValue(content);
            },
            // Trigger on blur to validate and update the model
            onBlur: () => {
              this.updateModelValue($(this.$refs.summernote).summernote('code'));
              this.$emit('blur');
            }
          }
        });
  
        // Set initial content if v-model is already holding a value
        $(this.$refs.summernote).summernote('code', this.value || '');
      },
      updateModelValue(content) {
        // Emit the value to the parent component using v-model
        this.$emit('input', content);
      }
    },
    watch: {
      value(newValue) {
        // Update Summernote content if v-model value is changed externally
        if ($(this.$refs.summernote).summernote('code') !== newValue) {
          $(this.$refs.summernote).summernote('code', newValue);
        }
      }
    }
  };
  </script>
  
  <!-- Add CSS and JS for Summernote -->
  <link href="/summernote-0.9.0-dist/summernote-bs4.css" rel="stylesheet">
  <script src="/summernote-0.9.0-dist/summernote-bs4.js"></script>
  
  <!-- Include jQuery and Bootstrap if not included -->
  <!-- <script src="/jquery/jquery.min.js"></script>
  <link href="/bootstrap/css/bootstrap.min.css" rel="stylesheet">
  <script src="/bootstrap/js/bootstrap.bundle.min.js"></script> -->
  